import { defaultSkodaBreakpoints } from '@skoda/k2tools-app-components';
import { ApiClient, Device, FormatService, ImporterPublicationProvider, ResourceProvider } from '@skoda/k2tools-app-services/lib';
import React from 'react';
import { AppConfig } from '../appConfig';
import { BaseAppSettings, Connection } from '../models/appSettings';
import { ApiService } from '../services/apiService';
import { ErrorService } from '../services/errorService';
import { SettingsService } from '../services/settingsService';
import { ICommonTrackingData } from '../tracking/trackingModels';
import { TrackingPrepare } from '../tracking/TrackingPrepare';

export const resourcesApi = 'api/resource/getdataresources';
export const importerPublicationApi = 'importer';
export const defaultNamespace = 'Strings';
export const apiClientHeaders = { accept: 'application/json;profile=camelcase' };
export const toolCode = 'OwnersManuals';
export const appSettingsApi = 'api/getAppSettings';

export type ServicesCollection = {
	config: AppConfig;
	apiClient: ApiClient;
	importerPublicationProvider: ImporterPublicationProvider;
	resourceProvider: ResourceProvider;
	formatService: FormatService;
	deviceProvider: Device;
	trackingPrepare: TrackingPrepare;
	errorService: ErrorService;
	settingsService: SettingsService;
	apiService: ApiService;
};

export function prepareServices(
	appSettings: BaseAppSettings,
	isWidget: boolean,
	connection: Connection,
	disableTracking?: boolean,
	trackingOverride?: Partial<ICommonTrackingData>
): ServicesCollection {
	const config = new AppConfig(appSettings, connection, isWidget);
	const apiClient = new ApiClient(config, apiClientHeaders);
	const settingsService = new SettingsService(apiClient, appSettingsApi);
	const importerPublicationProvider = new ImporterPublicationProvider(apiClient, importerPublicationApi, toolCode);
	const resourceProvider = new ResourceProvider(apiClient, defaultNamespace, resourcesApi);
	const formatService = new FormatService(importerPublicationProvider);
	const deviceProvider = new Device(defaultSkodaBreakpoints.values);
	const errorService = new ErrorService();
	const trackingPrepare = new TrackingPrepare(deviceProvider, config, settingsService, disableTracking, trackingOverride);
	const apiService = new ApiService(config);

	return {
		config,
		apiClient,
		importerPublicationProvider,
		resourceProvider,
		formatService,
		deviceProvider,
		errorService,
		settingsService,
		trackingPrepare,
		apiService,
	};
}

export const ServicesContext = React.createContext<ServicesCollection>(null);

export default ServicesContext;
